"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCalendarDates = exports.getNextMonth = exports.getPrevMonth = exports.getFirstDayOfMonth = exports.getMonthDays = void 0;
var dayjs = require("dayjs");
var types_1 = require("./types");
var getMonthDays = function (month, year) {
    if (month === void 0) { month = types_1.CUR_MONTH; }
    if (year === void 0) { year = types_1.CUR_YEAR; }
    return dayjs(new Date(year, month <= 0 ? 0 : month)).daysInMonth();
};
exports.getMonthDays = getMonthDays;
var getFirstDayOfMonth = function (month, year) {
    if (month === void 0) { month = types_1.CUR_MONTH; }
    if (year === void 0) { year = types_1.CUR_YEAR; }
    return (dayjs(new Date(year, month <= 0 ? 0 : month))
        .startOf('month')
        .toDate()
        .getDay() + 1);
};
exports.getFirstDayOfMonth = getFirstDayOfMonth;
var getPrevMonth = function (month, year) {
    if (month === void 0) { month = types_1.CUR_MONTH; }
    if (year === void 0) { year = types_1.CUR_YEAR; }
    var prevMonth = month > 0 ? month - 1 : 11;
    var prevYear = month > 0 ? year : year - 1;
    return { month: prevMonth, year: prevYear };
};
exports.getPrevMonth = getPrevMonth;
var getNextMonth = function (month, year) {
    if (month === void 0) { month = types_1.CUR_MONTH; }
    if (year === void 0) { year = types_1.CUR_YEAR; }
    var nextMonth = month < 11 ? month + 1 : 0;
    var nextYear = month < 11 ? year : year + 1;
    return { month: nextMonth, year: nextYear };
};
exports.getNextMonth = getNextMonth;
var generateCalendarDates = function (month, year) {
    if (month === void 0) { month = types_1.CUR_MONTH; }
    if (year === void 0) { year = types_1.CUR_YEAR; }
    var daysInMonth = (0, exports.getMonthDays)(month, year);
    var firstDayOfMonth = (0, exports.getFirstDayOfMonth)(month, year);
    var daysFromPrevMonth = firstDayOfMonth - 1;
    var daysFromNextMonth = types_1.CALENDAR_WEEKS * 7 - (daysFromPrevMonth + daysInMonth);
    var _a = (0, exports.getPrevMonth)(month, year), prevMonth = _a.month, prevYear = _a.year;
    var _b = (0, exports.getNextMonth)(month, year), nextMonth = _b.month, nextYear = _b.year;
    var prevMonthDays = (0, exports.getMonthDays)(prevMonth, prevYear);
    var prevMonthDates = __spreadArray([], new Array(daysFromPrevMonth), true).map(function (n, index) {
        var day = index + 1 + (prevMonthDays - daysFromPrevMonth);
        return new Date(prevYear, prevMonth, day, 0, 0);
    });
    var curMonthDates = __spreadArray([], new Array(daysInMonth), true).map(function (n, index) {
        var day = index + 1;
        return new Date(year, month, day, 0, 0);
    });
    var nextMonthDates = __spreadArray([], new Array(daysFromNextMonth), true).map(function (n, index) {
        var day = index + 1;
        return new Date(nextYear, nextMonth, day, 0, 0);
    });
    return { prevMonthDates: prevMonthDates, curMonthDates: curMonthDates, nextMonthDates: nextMonthDates };
};
exports.generateCalendarDates = generateCalendarDates;
